import { ReactElement } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import {
  PATH_TO_REGISTER_PARENT,
  PATH_TO_RECOVER_USERNAME,
} from "constants/navigation";

// Todo: Rename file and directories for app-frame to specify GIS
import GISAppLayout from "app-frame";
import UserRegistrationApp from "./topLevelApps/userRegistrationApp/UserRegistrationApp";
import RecoverUsernameApp from "./topLevelApps/recoverUsernameApp/RecoverUsernameApp";

import CommonRootProviders from "providers/CommonRootProviders";

function App(): ReactElement {
  const basename = process.env.REACT_APP_APP_ROUTE_PREFIX;

  return (
    <BrowserRouter basename={basename}>
      <CommonRootProviders>
        <Routes>
          <Route
            path={`${PATH_TO_REGISTER_PARENT}/*`}
            element={<UserRegistrationApp />}
          />
          <Route
            path={PATH_TO_RECOVER_USERNAME}
            element={<RecoverUsernameApp />}
          />
          <Route path="*" element={<GISAppLayout />} />
        </Routes>
      </CommonRootProviders>
    </BrowserRouter>
  );
}

export default App;
